import React, { PropsWithChildren } from 'react';
import { Placeholder, Segment } from 'semantic-ui-react';

export interface CardPlaceHolder {
  (props: PropsWithChildren<{}>): React.ReactElement;
  Course: React.FC;
  Directory: React.FC;
  Member: React.FC;
}

const LoadingCard: CardPlaceHolder = ({ children }) => {
  return (
    <Segment raised>
      <Placeholder fluid>{children}</Placeholder>
    </Segment>
  );
};

LoadingCard.Course = function Course() {
  return (
    <React.Fragment>
      <Placeholder.Header>
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Header>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </React.Fragment>
  );
};

LoadingCard.Directory = function Directory() {
  return (
    <React.Fragment>
      <Placeholder.Header>
        <Placeholder.Image />
        <Placeholder.Image />
      </Placeholder.Header>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </React.Fragment>
  );
};

LoadingCard.Member = function Member() {
  return (
    <React.Fragment>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </React.Fragment>
  );
};

export default LoadingCard;
